<template>
  <div
    class="grid gap-3 bg-[#EAEFF0] rounded p-[2em] sm:py-[2em] sm:px-[5em] text-center sm:text-start"
  >
    <span class="text-[19px] mx-auto sm:mx-0 pb-2 sm:pb-0">
      <CommonStarsRating :value="props.stars" />
    </span>
    <p class="text-[#253754] text-justify">
      {{ props.comment }}
    </p>
    <span class="font-bold row-start-2 sm:row-auto text-[1.2em]"
      >{{ props.customerName }}, {{ props.customerLocation }}</span
    >
  </div>
</template>

<script setup>
const props = defineProps({
  stars: {
    type: Number,
  },
  comment: {
    type: String,
  },
  customerName: {
    type: String,
  },
  customerLocation: {
    type: String,
  },
});
</script>
